import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';

@Component({
    selector: 'app-day-detail-modal',
    templateUrl: './day-detail-modal.component.html',
    styleUrls: ['./day-detail-modal.component.css'],
    imports: [NgFor, NgIf, LucideAngularModule]
})
export class DayDetailModalComponent {
  @Input() title: string = '';
  @Input() events: Array<any> = [];
  @Output() closeMeEvent = new EventEmitter();
  @Output() selectEvent = new EventEmitter<any>();

  closeEvent(event: any){
    if (event){
      event.stopPropagation();
      event.preventDefault();
    }
    this.closeMeEvent.emit();
  }
}